<template>
  <pilot-trials mode="screening" />
</template>

<script>
import PilotTrials from './PilotTrials.vue';

export default {
  name: 'Screening',
  components: { PilotTrials },
};
</script>
